module.exports = __webpack_public_path__ + "static/media/Icon 6.7019b820.jpeg";